"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Compass2 = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 16.325 16.325" },
        react_1.default.createElement(react_native_svg_1.Path, { fill: color, fillRule: "nonzero", d: "M 10.0085 6.14993 c 0.0661011 0.0440064 0.122803 0.100708 0.16684 0.166809 l 6.04889 9.07336 c 0.159058 0.238556 0.127594 0.556213 -0.0751343 0.758942 c -0.202759 0.202728 -0.520416 0.234192 -0.758972 0.0751343 l -9.07333 -6.04889 c -0.0661011 -0.0440064 -0.122803 -0.100708 -0.166809 -0.166809 L 0.101044 0.93512 C -0.0580139 0.696564 -0.0265808 0.378906 0.176178 0.176178 c 0.202728 -0.202759 0.520386 -0.234192 0.758942 -0.0751343 l 9.07339 6.04889 Z m -0.767334 0.934174 L 2.7702 2.77017 l 4.31396 6.47092 l 2.15701 -2.15698 Z" })));
};
Compass2.defaultProps = {
    color: 'currentColor',
    width: 16,
    height: 16,
};
exports.default = react_1.default.memo(Compass2);
